import { Empty as AntEmpty } from 'antd';
import { EmptyProps } from 'antd/lib/empty';
import React from 'react';

import cn from 'classnames';
import styles from './Empty.module.scss';

export interface IEmptyProps extends EmptyProps {
  size?: 'small' | 'large';
  orientation?: 'horizontal' | 'vertical';
}

/**
 * Empty component
 */
export const Empty: React.FC<IEmptyProps> = (props) => {
  const { size = 'large', orientation = 'vertical', className } = props;

  return (
    <AntEmpty
      className={cn(styles.Empty, styles[size], styles[orientation], className)}
      imageStyle={{ color: 'var(--gray-400)' }}
      {...props}
    />
  );
};
